import * as amplitude from '@amplitude/unified';

export function track(event, properties) {
  amplitude.track(event, properties);
}
